import React from "react";
import Table from "../../Common/Table";

import Permission from "../../Common/Permission";
import TableFields from "../../../constants/Campaign/TableFields.json";
import { getPath } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import { Pill } from "../../../constants/assets/containers";

const CampaignList = ({ handleClick = () => {}, campaignList = [] }) => {
  const allActions = MenuActionsMappings[MenuNames.CAMPAIGNS];

  const getFieldValue = (campaign, key) => {
    let smallKey = getPath(campaign, key, "NA");
    switch (key) {
      case "metadata":
        return smallKey.length > 50 ? smallKey.slice(0, 50) + "..." : smallKey;
      case "is_weekly_recurring":
        if (campaign["is_weekly_recurring"] === false) {
          return <Pill isFalse={true}>false</Pill>;
        }
        return <Pill isFalse={false}>true</Pill>;
      case "major_inventories_applicable":
        if (campaign["major_inventories_applicable"] === false) {
          return <Pill isFalse={true}>false</Pill>;
        }
        return <Pill isFalse={false}>true</Pill>;
      case "medium_inventories_applicable":
        if (campaign["medium_inventories_applicable"] === false) {
          return <Pill isFalse={true}>false</Pill>;
        }
        return <Pill isFalse={false}>true</Pill>;
      case "active":
        if (campaign["active"] === false) {
          return <Pill isFalse>Inactive</Pill>;
        }
        return <Pill isFalse={false}>Active</Pill>;
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.DETAIL, allActions.UPDATE]}
            notAllowedText="No Actions Allowed"
          >
            <span
              onClick={() => handleClick("Edit", campaign)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      case "cities":
        return (
          <span
            onClick={() => handleClick("Cities", campaign)}
            className={"edit-options cursor-pointer"}
          >
            View
          </span>
        );
      default:
        return smallKey;
    }
  };

  return (
    <Table
      list={campaignList}
      getFieldValue={getFieldValue}
      fields={TableFields}
    />
  );
};

export default CampaignList;
